export default {
  name: "AHJ",
  path: "/ahj",
  component: () => import("@/views/Ahj")
};
